(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name core.controller:LoginCtrl
   *
   * @description
   *
   */
  angular
    .module('core')
    .controller('LoginCtrl', LoginCtrl);

  function LoginCtrl($log, SessionService) {
    var vm = this;
/*    vm.errorKey = "";
    vm.errorDescription = "";*/

    $log.debug("Login handler -- start");
    var result = SessionService.init();

/*    if(!result){
      vm.errorKey = SessionService.errorKey;
      vm.errorDescription = SessionService.errorDescription;
    }*/

    //if(result == false){
    //  $scope.errorKey = SessionService.errorKey;
    //  $scope.errorDescription = SessionService.errorDescription;
    //}else{
    //  TimelineService.syncTimeline().then(function(response){
    //    console.log("Synced");
    //  }).catch(function(err){
    //    console.log("Error: " + err);
    //  });
    //}
  }
}());
